import React, { useState } from "react";
import {
  Button,
  EllipsisIcon,
  OpenIcon,
  Popover,
  PopoverContent,
  PopoverTrigger,
  SettingsIcon,
  TickIcon,
} from "@picklebet/ui";
import { List, ListItem } from "@/features/shell/components/shared/List/List";
import { notificationsService } from "services/notifications";

import { container, button } from "./ContextMenu.module.scss";

type ContextMenuProps = {
  hideOpen?: boolean;
  closePanel?: () => void;
};

export const ContextMenu = ({
  hideOpen = false,
  closePanel,
}: ContextMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeAll = () => {
    setIsOpen(false);
    closePanel?.();
  };

  return (
    <Popover open={isOpen} onOpenChange={(isOpen) => setIsOpen(isOpen)}>
      <PopoverTrigger asChild>
        <Button className={button} variant={`secondary`} size={`sm`}>
          <EllipsisIcon />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        sideOffset={-1}
        alignOffset={-15}
        align={"end"}
        className={container}
      >
        <List>
          <ListItem
            onClick={async () => {
              closeAll();
              notificationsService.dismissAllNotifications();
            }}
            icon={<TickIcon />}
            label={`Mark all as read`}
          />
          <ListItem
            to={`/preferences/notifications`}
            icon={<SettingsIcon />}
            label={`Notification Settings`}
            onClick={closeAll}
          />
          {!hideOpen && (
            <ListItem
              to={`/account/notifications`}
              icon={<OpenIcon />}
              label={`Open Notifications`}
              onClick={closeAll}
            />
          )}
        </List>
      </PopoverContent>
    </Popover>
  );
};
